/* eslint-disable no-dupe-keys */
export default {
  charging_package_definition: {
    name: '充电包模板',
    enabled: '已启用',
    disabled: '已禁用',
    status_update_success: '状态更新成功',
    // 属性
    prop: {
      name: '名称',
      power: '电量(度)',
      valid_time_type: '有效时间类型',
      fixed_days: '有效天数',
      station_ids: '适用电站',
      rule_description: '规则说明',
      status: '状态',
      charging_packages_count: '已发数量',
      created_at: '创建时间',
      updated_at: '更新时间',
      infinite_power: '无限电量 (难统计用电成本)',
      effective_time: '有效期',
      charging_periods: '充电优惠时段',
      vin_verify: '是否验证VIN'
    },
    // 列表页字段（search display也重用）
    columns: {
      name: '名称',
      power: '电量',
      valid_time_type: '有效时间类型',
      // begin_time: '开始时间',
      // end_time: '结束时间',
      // fixed_days: '有效天数',
      // station_ids: '适用电站',
      // rule_description: '规则说明',
      vin_verify: '是否验证VIN',
      status: '状态',
      charging_packages_count: '已发数量',
      ev_charging_stations: '适用电站',
      created_at: '创建时间',
      updated_at: '更新时间'
    },
    // Enum的属性
    valid_time_types: {
      fixed: '指定时间',
      after_taken: '获得后开始'
    },
    valid_time_display: {
      after_taken: '获得后 {0} 天内有效'
    },
    valid_time_tab_types: {
      fixed: '',
      after_taken: 'pending'
    },
    charge_station_prop: {
      name: '电站名',
      price_range_text: '价格区间'
    },
    statuses: {
      enabled: '可用',
      disabled: '禁用'
    },
    // Boolean的属性
    // 是否验证VIN
    vin_verifys: {
      true: '验证',
      false: '不验证'
    },
    // 占位提示
    placeholder: {
      search_keyword: '查询名称',
      input_name: '50元100度充电包',
      input_rule_description: '适用于某某充电站',
      select_station: '含监控及互联互通的充电站'
    },
    detail_tags: {
      detail: '基本信息',
      user_charging_packages: '用户充电包',
      orders: '充电订单',
      product_orders: '销售记录'
    },
    btn: {
      product: '在售商品',
      product_order: '购买记录'
    },
    titles: {
      basic_info: '基础信息',
      charge_station: '适用充电站'
    },
    // 校验
    validates: {
      periods_has_intersaction: '充电优惠时段存在交集'
    }
  }
}
